// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6 3.85L10.53 6.23C12.39 7.21 12.39 8.79 10.53 9.77L6 12.15C4.78 12.78 3.8 12.19 3.8 10.82L3.8 5.18C3.8 3.81 4.78 3.22 6 3.85Z',
];
